import React, { useEffect } from 'react';
import { CircularProgress, Box } from '@mui/material';

function CreatorRedirectionPage() {

  useEffect(() => {
    const timer = setTimeout(() => {
      window.location.href = 'https://app.oyecreators.com/';
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          backgroundColor: '#fff',
        }}
      >
        <CircularProgress size={60} thickness={5} color="primary" />
      </Box>
    </>
  )
}

export default CreatorRedirectionPage;
